import { API_BASE } from './api-client'

export interface AgentEndpoints {
  app: string
  api: string
  mcp: string
}

function withoutTrailingSlash(value: string) {
  return value.replace(/\/+$/, '')
}

function endpointWithPath(base: string, path: string) {
  const normalizedBase = withoutTrailingSlash(base)
  return normalizedBase.endsWith(path) ? normalizedBase : `${normalizedBase}${path}`
}

function deriveMcpFromApi(apiUrl: string): string | null {
  if (!apiUrl) return null
  try {
    const url = new URL(apiUrl)
    if (url.hostname === 'localhost' || url.hostname === '127.0.0.1') {
      url.port = '8788'
      url.pathname = '/mcp'
      url.search = ''
      url.hash = ''
      return url.toString()
    }
    url.hostname = url.hostname.replace(/^api\./, 'mcp.')
    url.pathname = '/mcp'
    url.search = ''
    url.hash = ''
    return url.toString()
  } catch {
    return null
  }
}

export function getAgentEndpoints(locationOrigin?: string): AgentEndpoints {
  const app =
    import.meta.env.VITE_APP_URL ??
    locationOrigin ??
    (typeof window !== 'undefined' ? window.location.origin : 'https://app.agentwiki.cc')
  const api = API_BASE || import.meta.env.VITE_API_URL || (app.includes('localhost') ? 'http://localhost:8787' : 'https://api.agentwiki.cc')
  const mcp =
    import.meta.env.VITE_MCP_URL ??
    deriveMcpFromApi(api) ??
    (app.includes('localhost') ? 'http://localhost:8788/mcp' : 'https://mcp.agentwiki.cc/mcp')

  return {
    app: withoutTrailingSlash(app),
    api: endpointWithPath(api, ''),
    mcp: endpointWithPath(mcp, '/mcp'),
  }
}
